import React from "react";
import { Navigate } from "react-router-dom";
import { getDecryptedUserFromCookie } from "../../../Components/utils/getCookie";
import { isAdminLoggedIn } from "../utils/session";

export default function SuperAdminRoute({ children }) {
  if (!isAdminLoggedIn()) {
    return <Navigate to="/" replace />;
  }
  const user = getDecryptedUserFromCookie();
  if (user?.type !== "SuperAdmin") {
    return <Navigate to="/dashboard" replace state={{ accessDenied: true }} />;
  }
  return children;
}
